const utils = {
    getRouteParams () {
        return JSON.parse(sessionStorage.getItem('routeParams'));
    },
    floatSum (floatOne, floatTwo) {
        var length1 = 0;
        var length2 = 0;
        try {
            length1 = floatOne.toString().split('.')[1].length;
        } catch (e) {
            // console.log(e);
        }
        try {
            length2 = floatTwo.toString().split('.')[1].length;
        } catch (e) {
            // console.log(e);
        }
        // 取出两者小数点后最大长度 求出放大比例 得出整数 再加 除
        var maxRate = Math.pow(10, Math.max(length1, length2));
        return (floatOne * maxRate + floatTwo * maxRate) / maxRate;
    },
    floatRide (floatOne, floatTwo) {
        var sumLength = 0,
            str1 = floatOne.toString(),
            str2 = floatTwo.toString();
        try {
            sumLength += str1.split(".")[1].length;
        } catch (e) {
            // console.log(e);
        }

        try {
            sumLength += str2.split(".")[1].length;
        } catch (e) {
            // console.log(e);
        }

        var maxRate = Math.pow(10, sumLength);
        //   乘法 去除小数点 转整型 累计所有小数点后数字长度 即为放大倍数后零的个数 除
        return (+str1.replace(".", "")) * (+str2.replace(".", "")) / maxRate;
    },
}

export default utils;